<template>

  <!-- 悬浮导航栏 -->
  <nav class="top-nav">
    <div class="nav-container">
      <div class="logo">
        <img alt="" src="/images/logo.png" style="width: 40px; height: 40px;"/>
        <span>院动通</span>
      </div>
      <div class="navbar">
        <router-link class="navbar-item" to="/home">首 页</router-link>
        <router-link class="navbar-item" to="/activity">热门活动</router-link>
        <router-link class="navbar-item" to="/news">新闻动态</router-link>
        <router-link class="navbar-item" to="/download">下载中心</router-link>
        <!--        <router-link to="/profile" class="navbar-item" @click.prevent="goProfile">个人中心</router-link>-->
        <router-link v-if="authStore.userFlag==='1'" class="navbar-item" to="/score">我的评价</router-link>
        <router-link v-else-if="authStore.userFlag === '3'" class="navbar-item" to="/approval">我的审批</router-link>
      </div>
      <div class="search-box">
        <input placeholder="请输入关键词" type="text">
        <button class="search-btn">🔍</button>
      </div>
      <div class="user-card">
        <!-- 消息通知 -->
        <div style="margin-right: 30px; align-items: center; display: none">
          <el-popover
              placement="bottom-start"
              title="消息通知"
              width="25%"
          >
            <div>sssssssssss</div>
            <template #reference>
              <img alt="" src="/images/msg-icon.png" style="width: 30px; height: 30px;"/>
            </template>
          </el-popover>
        </div>
        <!--        登录状态-->
        <el-dropdown v-if="authStore.isLoggedIn" placement="bottom-end"
        >
          <div class="user-info el-dropdown-link">

            <el-avatar
                src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
            />
            <div style="text-align: left">
              <p>{{ formatPhoneNumber(authStore.userInfo.username) }}</p>
              <div style="padding: 5px 2px;font-size: 12px">{{ getStatusText(authStore.userFlag) }}</div>
            </div>
            <el-icon>
              <CaretBottom/>
            </el-icon>
          </div>
          <!--          下拉菜单-->
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>
                <span @click="goProfile"> 个人中心</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span @click="logoOut">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <!--        未登录状态-->
        <div v-else class="login-btn" @click="openLoginModal">登录/注册</div>


      </div>
    </div>
  </nav>
  <!--  登录弹窗-->
  <LoginRegisterModal
      v-if="showLoginDialog"
      @close="showLoginDialog = false"
      @login-success="handleLoginSuccess"
  />

</template>

<script setup>

import LoginRegisterModal from "@/components/LoginRegisterModal.vue";
import {useAuthStore} from "@/stores/authStore";
import router from "@/router";

const authStore = useAuthStore();
authStore.checkAuth()

const openLoginModal = () => {
  // 假设你有一个全局的事件总线或者更简单的，直接修改 store 里的状态
  authStore.showLoginModal = true
}

const goProfile = () => {

  if (authStore.isLoggedIn) {
    router.push('/userProfile')
  } else {
    authStore.showLoginModal = true
  }
}

// 退出登录，清空用户信息
const logoOut = () => {
  authStore.clearAuthData()
  router.push('/home')

}

// 处理登录成功
const handleLoginSuccess = () => {
  authStore.showLoginModal = false
  console.log('登录成功，当前用户:', authStore.userFlag);
};

// 计算属性来格式化手机号
const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return '';
  }
  return phoneNumber.replace(/(\d{3})\d*(\d{4})/, '$1****$2');
}

const getStatusText = (status) => {
  switch (status) {
    case '1':
      return '评委';
    case '2':
      return '普通用户';
    case '3':
      return '审批员';
  }
}

</script>

<style scoped>
.navbar {
  display: flex;
  gap: 20px;
  padding: 10px;

}

.navbar a {
  text-decoration: none;
  color: #333;
  padding: 15px 5px;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 18px;
}

.navbar a.router-link-exact-active {
  color: #093880;
  border-bottom: 3px solid #093880;
  font-weight: bold;

}

/* 悬浮导航栏样式 */
.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 0 20px;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  max-width: 1200px;
  margin: 0 auto;
}

.logo {
  display: flex;
  font-size: 22px;
  font-weight: bold;
  color: #093880;
  height: 40px;
  line-height: 40px;
  text-align: center;
  justify-content: center;

  span {
    margin-left: 10px;

  }

}

.nav-links {
  display: flex;
  gap: 25px;
}

.nav-links a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: #093880;
}

.search-box {
  position: relative;
  display: none;
}

.search-box input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 200px;
}

.search-btn {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
}

.user-card {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.login-btn {
  border-radius: 90px;
  padding: 10px 20px;
  background-color: #eeeeee;
  cursor: pointer;
}

.login-btn:hover {
  background: #093880;
  color: #fff;
}


</style>